import React from 'react';
import { isNil } from 'lodash';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { FormInputContainerComponent, ItemComponent } from './InputWrappersComponent';

const renderOption = (option, index) => (
    <option key={index} value={option.value}>
        {option.label}
    </option>
);

class SelectFieldComponent extends React.Component {
    renderSelect = ({
        input,
        meta,
        name,
        label,
        isRequired,
        classNameInputContainer,
        defaultOptionLabel,
        defaultOptionValue,
        options
    }) => {
        return (
            <FormInputContainerComponent
                className={classNameInputContainer ? classNameInputContainer : ''}>
                {label && (
                    <label htmlFor={input.name} className="label">
                        {label}
                        {isRequired ? '*' : ''}
                    </label>
                )}
                <ItemComponent
                    className={`item select ${meta.touched && meta.error ? ' input-error' : ''}`}>
                    <select
                        {...input}
                        name={name}
                        id={`${input.name}-${meta.form}`}
                        className={`input input-select ${
                            meta.touched && meta.error ? ' input-error' : ''
                        }`}>
                        {defaultOptionLabel && (
                            <option value={defaultOptionValue ? defaultOptionValue : ''}>
                                {defaultOptionLabel}
                            </option>
                        )}
                        {options && options.map(renderOption)}
                    </select>
                </ItemComponent>
                {meta.touched && meta.error && <p className="color-err small">{meta.error}</p>}
            </FormInputContainerComponent>
        );
    };

    validateDefault = value =>
        this.props.isRequired && isNil(value) ? this.props.i18nForm.OPTION_REQUIRED : '';

    render() {
        const { validate } = this.props;
        return (
            <Field
                {...this.props}
                component={this.renderSelect}
                validate={validate ? validate : this.validateDefault}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        i18nForm: state.i18n.feature.form
    };
};

SelectFieldComponent.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultOptionLabel: PropTypes.string,
    defaultOptionValue: PropTypes.string,
    options: PropTypes.array,
    isRequired: PropTypes.bool
};

export default connect(mapStateToProps)(SelectFieldComponent);



// WEBPACK FOOTER //
// ./src/components/form/SelectFieldComponent.js